import SiteLink, { SiteLinkProps } from "common/ui/SiteLink";
import React from "react";

const DocsUrlResolver = {

    forHome(): string {
        return "/docs";
    },

    forIntegration(): string {
        return '/docs/integration';
    },

    forDisclaimer(): string {
        return '/docs/disclaimer';
    }
}

const Home = (props: SiteLinkProps) => <SiteLink.BaseSiteLink to={DocsUrlResolver.forHome()} {...props} />;
const Integration = (props: SiteLinkProps) => <SiteLink.BaseSiteLink to={DocsUrlResolver.forIntegration()} {...props} />;
const Disclaimer = (props: SiteLinkProps) => <SiteLink.BaseSiteLink to={DocsUrlResolver.forDisclaimer()} {...props} />;


export default {
    Home, Integration, Disclaimer
};